import commentApi from "@/api/comment/commentApi";
import CommentQueryTypes from "@/enums/CommentQueryTypes";

export default {
  namespaced: true,
  state: {
    groupId: '',
    title: 'Kommentare',
    comments: []
  },
  mutations: {
    init(state, {groupId}) {
      state.groupId = groupId;
    },
    setComments(state, comments) {
      state.comments = comments;
    }
  },
  actions: {
    async addOrUpdate({dispatch}, {groupId, comment}) {
      try {
        const response = await commentApi.addOrUpdate(groupId, comment);
        await dispatch('fetch', {groupId});
        await dispatch('NOTIFY_MSG', 'comment.notifications.save', {root: true});
        return Promise.resolve(response.data);
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },
    async fetch({commit, dispatch}, {groupId, queryType}) {
      try {
        if(queryType === undefined) queryType = CommentQueryTypes.default;
        const response = await commentApi.fetch(groupId, queryType);
        commit('setComments', response.data);
        return Promise.resolve(response.data);
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },
    async init({commit, dispatch}, {groupId, queryType}) {
      commit('init', {groupId});
      await dispatch('fetch', {groupId, queryType});
      return Promise.resolve();
    },
    async remove({dispatch}, {groupId, comment}) {
      try {
        await commentApi.remove(comment.id);
        await dispatch('fetch', {groupId});
        return Promise.resolve();
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },
  }
}
